// extracted by mini-css-extract-plugin
export var text = "_redotech-arbiter-lib-text-text";